import { reactive } from "vue";

export const globalState = reactive({
  userName: "",
  userProfilePicture: "",
  availablePoints: 0,
});
